module.exports = __webpack_public_path__ + "static/media/smallLogo.5c409ab7.png";